import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export type DescriptionDialogProps = {
  description: string;
  index?: number;
  onDialogOpen?: () => void;
};

export const DescriptionDialog = ({
  description,
  index = 0,
}: Readonly<DescriptionDialogProps>) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <IconButton onClick={handleOpen}>
        <InfoOutlinedIcon data-testid={`open-description-dialog-${index}`} />
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Description
          <IconButton
            aria-label="close-dialog"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '180px', minWidth: '320px' }}>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
